/**
 * Merges two sets of HTTP headers into one. If the same header is present in both sets, the value from the primaryHeaders will be used.
 * Headers are case-insensitive, but the case of keys from the primaryHeaders will be preserved in the result.
 *
 * @param {Object|null|undefined} primaryHeaders - The primary set of headers. These will take precedence over secondaryHeaders.
 * @param {Object|null|undefined} secondaryHeaders - The secondary set of headers. These will be added to the primaryHeaders, unless the same header is already present in primaryHeaders.
 * @returns {Object} The merged set of headers.
 */
export default function mergeRequestHeaders(primaryHeaders, secondaryHeaders) {
	if (!primaryHeaders && !secondaryHeaders) return {}
	if (!primaryHeaders) return secondaryHeaders || {}
	if (!secondaryHeaders) return primaryHeaders || {}

	const lowerCasedPrimaryHeaderNames = Object.keys(primaryHeaders).map(key => key.toLowerCase())

	secondaryHeaders = Object.fromEntries(
		Object.entries(secondaryHeaders).filter(([key]) => !lowerCasedPrimaryHeaderNames.includes(key.toLowerCase()))
	)

	return {...primaryHeaders, ...secondaryHeaders}
}
